const _ = require("lodash");

const AppReducer = (state, action) => {
  switch (action.type) {
    case "LOAD_LIST":
      // const it = JSON.parse(localStorage.getItem("mlist"));
      const a = _.uniqBy(action.data.list, (e) => {
        e["orderb"] = e.ordern / 100;
        e["orderd"] = 0;
        return e.group_name;
      });
      // const b = action.data.list.map((i) => {
      //   i["orderd"] = 0;
      //   return i;
      // });
      // console.log("*****", b);
      // console.log("=====>>>>", _.orderBy(a, ["ordern"], ["asc"]));
      return {
        ...state,
        applist: action.data.list,
        sidemenulist: _.orderBy(a, ["orderb"], ["asc"]),
        isexternal: action.data.isexternal,
      };
    case "HELP_LIST":
      // console.log("=====>>>>", _.orderBy(a, ["ordern"], ["asc"]));
      return {
        ...state,
        helplist: _.orderBy(action.data, ["software_id"], ["desc"]),
      };
    case "SEARCH_APP":
      // console.log("=====>>>>", _.orderBy(a, ["ordern"], ["asc"]));
      return {
        ...state,
        searchtxt: action.data,
      };
    case "SIDEMENU_CLICKED":
      // console.log("=====>>>>", _.orderBy(a, ["ordern"], ["asc"]));
      return {
        ...state,
        sidemenuclicked: action.data,
      };

    // case "CHANGE_MENU":
    //   var list = _.orderBy(action.data.list, ["ordern"], ["asc"]);
    //   var listFiltered = list;
    //   var pageTotal =
    //     _.round(list.length / state.perPage, 1) >=
    //     _.round(list.length / state.perPage, 0)
    //       ? _.round(list.length / state.perPage, 0) + 1
    //       : _.round(list.length / state.perPage, 0);

    //   return {
    //     ...state,
    //     group:
    //       action.data.isexternal === 0
    //         ? action.data.group
    //         : action.data.group.filter(
    //             (a) =>
    //               a.id === 9 ||
    //               a.id === 2 ||
    //               a.id === 3 ||
    //               a.id === 4 ||
    //               a.id === 8
    //           ),
    //     isexternal: action.data.isexternal,
    //     list: list,
    //     listFiltered: listFiltered.slice(0, 12),
    //     pageTotal: pageTotal,
    //     check: action.data,
    //     chk: 0,
    //   };

    case "CLICK_MENU":
      return {
        ...state,
        filterGroup: action.data,
        listFiltered:
          action.data !== 0
            ? state.list.filter((a) => a.group_id === action.data)
            : _.orderBy(state.list.slice(0, 12), ["ordern"], ["asc"]),
        check: action.data,
        chk: 44,
      };

    case "CLICK_PAGINATION":
      return {
        ...state,
        listFiltered:
          action.data === 1
            ? state.list.slice(0, 12)
            : action.data === 2
            ? state.list.slice(13, 24)
            : action.data === 3
            ? state.list.slice(25, 36)
            : action.data === 4
            ? state.list.slice(37, 48)
            : action.data === 5
            ? state.list.slice(49, 60)
            : null,
        pageCurrent: action.data,
        check: 0,
        chk: 0,
      };

    default:
      return state;
  }
};
export default AppReducer;
